
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getEnvironment } from "../helpers/HelperFunctions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
let firebaseConfig = {
    apiKey: "AIzaSyCttkz6E4uEg7IBx1vBnOxLRVZkuUtgJrI",
    authDomain: "scribe-it-admin-web.firebaseapp.com",
    projectId: "scribe-it-admin-web",
    storageBucket: "scribe-it-admin-web.appspot.com",
    messagingSenderId: "1004974721609",
    appId: "1:1004974721609:web:b13e3ef622063e16afcd98",
    measurementId: "G-C7MH4J3TLV"
};

if (getEnvironment() === "production") {
    firebaseConfig = {
        apiKey: "AIzaSyCSL5K9urY29jYo1bve5T7xRtxHFkjX2Ew",
        authDomain: "scribeit-2dfc9.firebaseapp.com",
        projectId: "scribeit-2dfc9",
        storageBucket: "scribeit-2dfc9.appspot.com",
        messagingSenderId: "454276543989",
        appId: "1:454276543989:web:c8438dd2edc18ec66b1cbc",
        measurementId: "G-PWVTXSEWHN"
    };
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage();
const firestore = getFirestore(app);

export { firestore, storage };